import React, { Component } from 'react';
import Header from './parts/Header';
import Menu from './parts/Menu';
import api from '../api/api';
import auth from '../api/auth';
import multilanguage from '../multilanguage';
import DLoader from "./parts/DLoader";
import cart from '../api/cart';
import {NotificationManager} from 'react-notifications';
import emitter from 'tiny-emitter/instance';

class DPromotionPackages extends Component {

    constructor(props){
        super(props);
        this.state = {
            selected: 0,
            promotionPackages: [],
            loading: true
        }
    }

    componentDidMount(){
        api.get('/ServiceKnowledgebase/promotion-package/service')
        .then(res => {
            this.setState({promotionPackages: res.data, loading: false})
            
        });
        emitter.on("cartUpdate", ()=>{
            this.forceUpdate()
        });
    }   

    additemstocart(){
        cart.addItems(this.state.services);
        NotificationManager.success(multilanguage.go_to_cart);
    }

    expandDescription(e){
        var item = e.target.closest('.store_list_test_item_container');
        var description = null;
        for (var i = 0; i < item.childNodes.length; i++) {
            if (item.childNodes[i].className == "store_list_item_description") {
                description = item.childNodes[i];
            break;
            }        
        }
        if(description.style.maxHeight != '100px'){
            description.style.maxHeight = '100px';
        }
        else{
            description.style.maxHeight = '';
        }
        
    }

    render() { 
        return ( 
            <div className="desktop_container">
                <Menu screenProps={this.props.history} />
                <div className="desktop_container_content">
                    <Header screenProps={this.props.history} />
                    <div className="d_main_content">
    
                        <div className="d_page_title_container">
                            <div className="d_page_title_container_store">
                                <div className="d_page_title_store">{multilanguage.medical_library}</div>
                                {/* <div className="d_store_header_search">
                                    <img src={require('../assets/images/desktop/search1.svg')} />
                                    <input placeholder={multilanguage.search_simple} type="text" />
                                </div>  */}
                                <div className="d_store_menu_buttons inactive" onClick={() => this.props.history.push('/library')}>
                                    <svg width="18" height="23" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.0005 22C11.198 22 13.2167 21.1539 14.6578 19.7992C16.0994 18.4456 17 16.5503 17 14.4856C17 11.5062 12.7481 5.65028 9.93677 1.72348C9.32448 0.741779 8.67602 0.776054 8.06323 1.72348C5.2524 5.65028 1 11.5405 1 14.4856C1 16.5503 1.90111 18.4456 3.34219 19.7992C4.78376 21.1539 6.80197 22 9.0005 22Z" stroke="#00539F" strokeLinejoin="round"/>
                                        <path d="M14.8699 13C15.4961 15.2531 13.7507 17.808 12 18" stroke="#00539F" strokeLinecap="round"/>
                                    </svg>
                                    <span>{multilanguage.single_tests}</span>
                                </div>
                                <div className="d_store_menu_buttons inactive" onClick={() => this.props.history.push('/packages')}>
                                    <svg id="Group_255" data-name="Group 255" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 53.352 47.696">
                                        <path id="Path_48" data-name="Path 48" d="M.545,3.176C2.689,6.733,5.83,9.712,9.028,12.6c4.074,3.682,8.229,7.191,12.5,10.8a2.23,2.23,0,0,0,2.794,0c6.7-5.672,14.2-11.119,19.51-18.109A18.5,18.5,0,0,0,47.895-6.737c-.363-6.113-4.541-12.037-10.724-13.353a12.718,12.718,0,0,0-9.077,1.406,15.083,15.083,0,0,0-4.387,4.061,1.067,1.067,0,0,1-.478.419c-.754.286-1.35-.828-2.091-1.657a13.083,13.083,0,0,0-9.494-4.522q-.11,0-.22,0A13.76,13.76,0,0,0-1.19-11.105,16.392,16.392,0,0,0-1,.055q.269.695.59,1.362A2.76,2.76,0,0,1,.784,1.47c2.434.353,4.99.758,7.284.166,2.44-.629,2.8-4.828,3.838-6.4a1.894,1.894,0,0,1,1.708-1.092,1.146,1.146,0,0,1,.894.293c1.045.693,1.462,2.015,1.912,3.114C17.7.662,18.406,4.084,20.2,6.906a4.961,4.961,0,0,0,.653.754A3.224,3.224,0,0,0,21.892,6.3c1.748-3.133,2.435-6.819,4.656-9.851.067-.093.137-.183.21-.271a2.619,2.619,0,0,1,3.718-.247A19.427,19.427,0,0,1,34.136-.412a1.208,1.208,0,0,1,.228.525c.057.775-1.042,1.185-1.669.423a13.545,13.545,0,0,0-3.677-3.5c-.687-.373-.917.173-1.217.618-2.182,3.236-2.768,7.538-5.13,10.6a2.149,2.149,0,0,1-2.41,1.017c-1.156-.443-1.713-1.7-2.206-2.731C16.614,3.534,15.841.255,14.394-2.8a4.3,4.3,0,0,0-.795-1.3,4.055,4.055,0,0,0-.549.793c-1.3,2.594-1.733,5.923-4.637,6.631A20.191,20.191,0,0,1,.545,3.176M11.662-22.1a15.037,15.037,0,0,1,11.263,5.687c.064-.079.128-.157.193-.233a15.033,15.033,0,0,1,17.226-4.219c8.285,3.606,11.887,14.884,7.02,23.873-3.281,6.061-8.844,10.48-14.072,14.958-2.617,2.236-5.218,4.456-7.837,6.729a4,4,0,0,1-5.061,0C14.49,19.584,8.3,14.847,3.048,9.169-.2,5.66-2.993,1.485-3.638-3.362c-.817-6.133,1.66-12.75,6.807-16.223A15.163,15.163,0,0,1,11.662-22.1" transform="translate(3.791 22.1)" fill="#00539f" fill-rule="evenodd"/>
                                    </svg>
                                    <span>{multilanguage.packages}</span>
                                </div> 
                                {auth.auth.user.role == 'practitioner' ? 
                                <div className="d_store_menu_buttons inactive" onClick={() => this.props.history.push('/my_packages')}>
                                <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M14 4.98127C14 7.75281 11.7612 10 9 10C6.27612 10 4 7.79026 4 5.01873C4 2.24719 6.23881 0 9 0C11.7612 0 14 2.20974 14 4.98127ZM12.8806 5.01873C12.8806 2.84644 11.1269 1.1236 9 1.1236C6.87313 1.1236 5.15672 2.84644 5.15672 4.98127C5.15672 7.11611 6.83582 8.91386 9 8.91386C11.1642 8.91386 12.8806 7.19101 12.8806 5.01873Z" fill="#00539F"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.84508 12H13.1542C15.2994 12 17.0398 13.72 16.9993 15.8V16.2C16.9993 18.28 15.2994 20 13.1542 20H3.84508C1.74041 20 0 18.32 0 16.2V15.8C0 13.72 1.69993 12 3.84508 12ZM13.1947 18.8C14.6518 18.8 15.8255 17.64 15.8255 16.2V15.8C15.8255 14.36 14.6518 13.2 13.1947 13.2H3.88556C2.42847 13.2 1.25471 14.36 1.25471 15.8V16.2C1.25471 17.64 2.42847 18.8 3.88556 18.8H13.1947Z" fill="#00539F"/>
                                </svg>
                                    <span className="text-no-wrap">{multilanguage.my_packages}</span>
                                </div> : null}
                                {auth.auth.user.role == 'practitioner' ? 
                                <div className="d_store_menu_buttons active" onClick={() => this.props.history.push('/promotion_packages')}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
                                        <path fill="white" d="M300-520q-58 0-99-41t-41-99q0-58 41-99t99-41q58 0 99 41t41 99q0 58-41 99t-99 41Zm0-80q25 0 42.5-17.5T360-660q0-25-17.5-42.5T300-720q-25 0-42.5 17.5T240-660q0 25 17.5 42.5T300-600Zm360 440q-58 0-99-41t-41-99q0-58 41-99t99-41q58 0 99 41t41 99q0 58-41 99t-99 41Zm0-80q25 0 42.5-17.5T720-300q0-25-17.5-42.5T660-360q-25 0-42.5 17.5T600-300q0 25 17.5 42.5T660-240Zm-444 80-56-56 584-584 56 56-584 584Z"/>
                                    </svg>
                                    <span className="text-no-wrap">{multilanguage.promotion_packages}</span>
                                </div> : null}
                            </div>
                        </div>
                        
                        <div className="d_packages_detail_products">
                        {this.state.loading ? <DLoader /> : null}
                        {!this.state.loading && this.state.promotionPackages.length == 0 ? 
                            <div>Brak aktywnych promocji</div> 
                            : null
                        }
                        {this.state.promotionPackages.map((test) => {
                            
                                return(
                                    <div index={test.id} className="store_list_test_item_container">
                                        <div className="store_list_item_line">
                                            <div className="d_store_list_item_start">
                                                <span onClick={() => this.props.history.push('/product_detail/'+test.id)} className="store_list_item_name">{test.name}</span>
                                                <div onClick={(e) => this.expandDescription(e)} className="store_list_item_see_more">{multilanguage.see_more}</div>
                                            </div>
                                            {auth.auth.user.role == 'practitioner' ? 
                                            <div className="d_store_list_item_end">
                                                <div class="store_lsit_item_pret_promotion_package_container">
                                                    <span className="store_lsit_item_pret_promotion_package_discount">{test.price} {multilanguage.currency}</span>
                                                    <span className="store_lsit_item_pret_promotion_package">{test.discountPrice} {multilanguage.currency}</span>
                                                </div>
                                                <div 
                                                                onClick={() => cart.addItem(test)}
                                                                className={cart.findItem(test.id) !== null  ? "new_order_checked_pacient" : "new_order_unchecked_pacient"}>
                                                                    <img src={require('../assets/images/whiteCheck.svg')} />
                                                                </div>
                                            </div>: null}
                                        </div>
                                        <div className="store_list_item_description">
                                            <div className="store_list_item_description_inner">
                                                {test.description}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
         );
    }
}
 
export default DPromotionPackages;